import styled from 'styled-components'
import { Link } from 'react-router-dom'

import colors from './colors'

const InternalLink = styled(Link)`
  color: ${colors.blue};
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:active {
    text-decoration: underline;
  }
`
const ExternalLink = styled.a`
  color: ${colors.blue};
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:active {
    text-decoration: underline;
  }
`
const AppAction = styled.span`
  color: ${p => p.light ? colors.tertiaryText : colors.blue};
  background: ${p => p.light ? 'transparent' : colors.lightBlue};
  border-radius: 100px;
  padding: .33rem .66rem;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:active {
    text-decoration: underline;
  }
`
const HeaderLink = styled(Link)`
  color: ${colors.primaryText};
  text-decoration: none;
  font-size: 1.2rem;
  cursor: pointer;
`
const AppLogo = styled(Link)`
  color: ${colors.primaryText};
  text-decoration: none;
  font-size: 1.2rem;
  margin: 0 0 2rem;

  div {
    display: inline-block;
  }

  @media (max-width: 500px) {    
    display: none;
  }
`
const HeaderButton = styled.div`
  color: ${colors.primaryText};
  text-decoration: none;
  font-size: 1.2rem;
  float: ${p => p.right ? 'right' : 'none'};
  display: block;
  cursor: pointer;
`
const MobileFooterLink = styled(Link)`
  color: ${colors.secondaryText};
  text-decoration: none;
  cursor: pointer;
  opacity: .8;
  background: ${colors.lightGray};
  border-radius: 100px;
  padding: .66rem 1.25rem;

  &:hover,
  &:active {
    opacity: 1;
  }

  ion-icon {
    font-size: 1rem;
    margin: -2px .6rem -2px 0;
    display: inline-block;
  }
`
const AddLink = styled(Link)`
  text-decoration: none;
  background: ${colors.blue};
  color: white;
  border-radius: 100px;
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  text-align: center;
  opacity: .95;
  box-shadow: 0 5px 10px 0px hsla(0, 0%, 0%, 0.1);
  z-index: 100;
  
  line-height: 77px;
  width: 60px;
  height: 60px;

  ion-icon {
    font-size: 30px;
  }

  @media (max-width: 500px) {
    width: 40px;
    height: 40px;
    line-height: 51px;

    ion-icon {
      font-size: 24px;
    }
  }

  &:hover {
    opacity: 1;
  }
`

export {
  InternalLink,
  ExternalLink,
  AppAction,
  HeaderLink,
  AppLogo,
  HeaderButton,
  MobileFooterLink,
  AddLink,
}



// WEBPACK FOOTER //
// ./src/styles/links.js